// 旧版
import gxd from '../less/commont.less'
import 'element-ui/lib/theme-chalk/index.css';
let Agentcode = "ml";
export default {
  gxd,
  Agentcode
};

// 新版
// import gxd from '../less/commont_01.less'
// import '../new-theme-chalk/index.css';
// let Agentcode = "xx";
// export default {
//   gxd,
//   Agentcode
// };



// WEBPACK FOOTER //
// ./src/assets/js/Css_moudules.js